module.exports = (key, ...args) => {
  const data = args.slice(0, -1);
  return window.INKIVE.TranslateHelper.translate(key, data.length && data);
};
